export const QUOTE_ITEM_LENS_TYPE = {
    SINGLE_VISION: 'single-vision',
    PROGRESSIVE: 'multifocal',
} as const;
